import React from "react";

import { STATES_INVERTED } from "Constants";
import {
  validateBeforeToday,
  validateBornAt,
  validateDate,
  validatePhone,
  validateRequired,
  validateZipCode,
  validatePhysicalAddress,
  validateNotPolygamy,
  composeValidators,
} from "Utils/Validations";

import { SIFinalFormField, SIFormSelect, SIFormRadioGroup } from "Common/forms";
import { zipCodeMask, phoneMask, dateMask, currencyMask } from "Common/forms/masks";

export const PhysicalAddress = ({ ...rest }) => (
  <SIFinalFormField
    name="homeAddress"
    label="Physical Address"
    hint="Cannot be a PO Box"
    validate={composeValidators(validateRequired, validatePhysicalAddress)}
    noBounce
    {...rest}
  />
);

export const AddressCity = ({ ...rest }) => <SIFinalFormField name="city" label="City" validate={validateRequired} noBounce {...rest} />;

export const AddressState = ({ ...rest }) => (
  <SIFinalFormField
    name="state"
    label="State"
    component={SIFormSelect}
    componentProps={{ options: STATES_INVERTED }}
    validate={validateRequired}
    noBounce
    {...rest}
  />
);

export const AddressZipCode = ({ ...rest }) => (
  <SIFinalFormField
    name="zipCode"
    label="Zip Code"
    validate={composeValidators(validateRequired, validateZipCode)}
    componentProps={{ mask: zipCodeMask }}
    noBounce
    {...rest}
  />
);

export const HomePhoneNumber = ({ ...rest }) => (
  <SIFinalFormField
    name="homePhoneNumber"
    label="Home Phone Number"
    componentProps={{ mask: phoneMask }}
    validate={composeValidators(validateRequired, validatePhone)}
    noBounce
    {...rest}
  />
);

export const WorkPhoneNumber = ({ ...rest }) => (
  <SIFinalFormField
    name="workPhoneNumber"
    label="Work Phone Number"
    hint="optional"
    componentProps={{ mask: phoneMask }}
    validate={validatePhone}
    noBounce
    {...rest}
  />
);

export const Gender = ({ ...rest }) => (
  <SIFinalFormField
    component={SIFormRadioGroup}
    name="gender"
    label="Gender"
    componentProps={{ options: { male: "Male", female: "Female" } }}
    validate={validateRequired}
    noBounce
    {...rest}
  />
);

export const TobaccoUser = ({ ...rest }) => (
  <SIFinalFormField
    component={SIFormRadioGroup}
    name="tobaccoUser"
    label="Do you currently use tobacco?"
    componentProps={{ options: { Yes: "Yes", No: "No" } }}
    validate={validateRequired}
    noBounce
    {...rest}
  />
);

export const MaritalStatus = ({ ...rest }) => (
  <SIFinalFormField
    component={SIFormRadioGroup}
    name="maritalStatus"
    label="Marital Status"
    componentProps={{
      options: {
        single: "Single",
        married: "Married",
        domestic_partner: "Domestic Partner",
      },
    }}
    validate={validateRequired}
    noBounce
    {...rest}
  />
);

export const FirstName = ({ ...rest }) => <SIFinalFormField label="First Name" name="firstName" validate={validateRequired} noBounce {...rest} />;

export const MiddleInitial = ({ ...rest }) => <SIFinalFormField label="Middle Initial" name="middleInitial" maxLength={1} noBounce {...rest} />;

export const LastName = ({ ...rest }) => <SIFinalFormField label="Last Name" name="lastName" validate={validateRequired} noBounce {...rest} />;

export const BornAt = ({ ...rest }) => (
  <SIFinalFormField
    name="bornAt"
    label="Date of Birth"
    hint="MM/DD/YYYY"
    componentProps={{ mask: dateMask }}
    validate={composeValidators(validateRequired, validateDate, validateBeforeToday, validateBornAt)}
    noBounce
    {...rest}
  />
);

export const SalaryAmount = ({ ...rest }) => (
  <SIFinalFormField
    name="salaryAmount"
    label="Annual Salary"
    guidance="Salary is required by insurance carriers for some insurance types"
    componentProps={{ mask: currencyMask }}
    validate={validateRequired}
    parse={(value) => (!value ? 0 : parseFloat(value.replace(/[^0-9.]/g, "")))}
    format={(value) => (value === 0 ? "" : value)}
    noBounce
    {...rest}
  />
);

export const DependentType = ({ needsPolygamyValidation, ...rest }) => (
  <SIFinalFormField
    label="Relationship"
    name="dependentType"
    component={SIFormRadioGroup}
    componentProps={{
      options: {
        spouse: "Spouse",
        domestic_partner: "Domestic Partner",
        child: "Child",
      },
    }}
    validate={needsPolygamyValidation ? composeValidators(validateRequired, validateNotPolygamy) : validateRequired}
    noBounce
    {...rest}
  />
);
